import type { BankfileMappingSuggestion } from '@payer-admin-ui/api/src/ai/types/BankfileMappingSuggestion';
import { mappingTypeValues, type MappingType } from '@payer-admin-ui/api/src/bankfilepayments/bankFilePaymentTypes';
import { generateUUID } from '@payer-admin-ui/components-v2/src/utils/strings';
import type { DraftInvoiceMapping } from './AddMappingModalStateConstants';

export const toDraftInvoiceMappingsFromBankfileSuggestions = (
  suggestions: BankfileMappingSuggestion[],
): Record<string, DraftInvoiceMapping> => {
  const draftMappings: Record<string, DraftInvoiceMapping> = {};

  for (const suggestion of suggestions) {
    const runningNumber = String(suggestion.runningNumber);
    if (!runningNumber) continue;

    const amount = Number(suggestion.amount);
    if (!Number.isFinite(amount) || amount <= 0) continue;

    const mappingTypeRaw = String(suggestion.mappingType ?? '')
      .trim()
      .toUpperCase();
    const mappingType: MappingType =
      (mappingTypeValues as readonly string[]).includes(mappingTypeRaw) && mappingTypeRaw !== 'REFUND'
        ? (mappingTypeRaw as MappingType)
        : mappingTypeRaw === 'REFUND'
          ? 'MANUAL_REFUND'
          : 'NORMAL';

    const id = generateUUID();
    draftMappings[id] = {
      id,
      number: runningNumber,
      amount,
      mappingType,
      isAiSuggested: true,
      isConfirmed: false,
    };
  }

  return draftMappings;
};
